import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import {
  Step,
  StepConnector,
  Stepper,
  Typography,
} from '../../../base';

const styles = theme => ({
  progressTitle: {
    fontSize: theme.typography.fontSize * 0.75,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(),
  },
  progressBar: {
    padding: 0,
    paddingLeft: theme.spacing(3),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),

    '& .stepContainer': {
      marginBottom: theme.spacing(0.5),
      flexDirection: 'row',
    },

    '& .stepLabel': {
      maxWidth: 200,
      marginLeft: theme.spacing(),

      [theme.breakpoints.up('sm')]: {
        maxWidth: 90,
      },
    },

    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(),
      paddingLeft: 0,
    },

    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(),
    },
  },
  stepConnector: {
    marginLeft: 10,

    [theme.breakpoints.up('sm')]: {
      marginTop: -(theme.spacing(0.5)),
      marginLeft: 0,
      maxWidth: 30,
      marginRight: theme.spacing(),
    },
  },
  statusContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
})

const JobProgress = ({
  classes: c,
  steps,
  gt,
}) => {
  return (
    <div>
      <Typography variant='caption' className={c.progressTitle}>{gt.Progress.title}</Typography>
      <Stepper
        className={c.progressBar}
        connector={<StepConnector className={c.stepConnector} />}
        classes={{ stepContainer: c.stepContainer }}
      >
        {steps.map(step => (
          <Step key={step.id} step={step} />
        ))}
      </Stepper>
    </div>
  )
}

export default withStyles(styles)(JobProgress);



// WEBPACK FOOTER //
// ./src/components/Jobs/Job/JobProgress/JobProgress.js